import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "submit"]
  static values = { id: Number }

  connect() {
    console.log("ChatController connected, chat_id:", this.idValue)
    this.scrollToBottom()
    
    // Listen for turbo stream events to auto-scroll when new messages arrive
    document.addEventListener("turbo:stream-render", this.handleNewMessage.bind(this))
  }

  disconnect() {
    document.removeEventListener("turbo:stream-render", this.handleNewMessage.bind(this))
  }

  handleNewMessage() {
    // Scroll to bottom when new content is rendered
    this.scrollToBottom()
  }

  scrollToBottom() {
    const messages = document.getElementById("messages")
    if (messages) {
      messages.scrollTop = messages.scrollHeight
    }
  }
  
  handleKeydown(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      
      if (this.inputTarget.value.trim() !== "") {
        this.inputTarget.form.requestSubmit()
      }
    }
  }
  
  clearInput() {
    if (this.hasInputTarget) {
      this.inputTarget.value = ""
    }
  }
}